import { GenericModel } from "../../../generic.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { VendorModel } from "../../common/vendor.model";


export class MembershipCardModel extends GenericModel {
    public number: number;
    public vendorArray: VendorModel[];
    // TODO public traveller: {xRef: "T.1"}

    protected fromJson(json?: any): boolean {
        this.number = json.number ?? null;
        this.vendorArray = makeModel(json.vendorArray, VendorModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return true;
    }
}